import React, { useEffect, useState,useRef,useMemo} from "react";
import { sortSizes } from "@/helpers/pdpHelpers";
import {
    mapVariants,
    selectVariant,
    getProductOptions,
    getHexCodeData,
  } from "@/helpers/pdpHelpers/pdpVariantHelpers";
  import {
    getVariantPrice,
  } from "@/helpers/pdpHelpers/priceHelpers";
import { generalConstants } from "@/utils/constants";


  function hideZeroPriceColor(colors, variantMap){
    Object.values(colors).map((eachColor, index) => {
      let nonZeroVariant = false;
      if(typeof variantMap[eachColor] != "undefined" && variantMap[eachColor]){
        Object.values(variantMap[eachColor]).map((vari) => {
          const variantPrice = getVariantPrice(vari);
          let priceToCheck = variantPrice?.returnedSalePrice ? variantPrice.returnedSalePrice : variantPrice.returnedPrice;
          if (priceToCheck !== "$0") {
            nonZeroVariant = true;
            return;
          }
        });
      }
      if(!nonZeroVariant){
        delete colors[index];
      }
    });
    return colors;
  }

function getFinalOptions(array1, array2, variantMap, type) {
    let finalArray1 = [];
    let finalArray2 = [];
    let hexCodeArray = [];
    let showQuickBuy = false;
    let singleVariant = false
    let showSize = false;
    if(array1 && array1.length > 1 && array2 && array2.length == 1) {
      showQuickBuy = true;
    } 
    if(array2 && array2.length > 1 && array1 && array1.length == 1) {
        showQuickBuy = true;
    } 
    if(!showQuickBuy && array1 && array1.length == 1 && array2 && array2.length == 1) {
        showQuickBuy = true;
        singleVariant = true;
    }
    
    if(showQuickBuy) {
      for (let [key, value] of Object.entries(variantMap)) {
        let hexcode = '';
        let color = '';
        for (let [key1, value1] of Object.entries(value)) {
          if(value1.availableForSale) {
            finalArray1.push(key1);
            hexcode = value1?.hexColor?.value;
            color = key;
            
          }
        }
        if(hexcode) {
          hexCodeArray.push([hexcode]);
        }
        if(color) {
          finalArray2.push(color);
        }
      }
      finalArray1 = [...new Set(finalArray1)];
      finalArray2 = [...new Set(finalArray2)];
      //sort is required only for letters
      if(type == 'letter') {
        finalArray2 = finalArray2.sort();
      }

      if(finalArray1 && finalArray1.length == 1 && finalArray2 && finalArray2.length == 1) {
        singleVariant = true;
        if(finalArray1 && finalArray1.length > 1 && finalArray1[0].toLowerCase() != generalConstants.one_size) {
          showSize = true;
          singleVariant = false;
        }
      }
    }
    if(finalArray1.length && finalArray2.length) {
      sortSizes(finalArray1);
      if(variantMap){
        if(finalArray2 && finalArray2.length > 0){
          finalArray2 = hideZeroPriceColor(finalArray2, variantMap);
        }
      }  
    } else {
      showQuickBuy = false;
    }
    
    let ret = {
      finalArray1: finalArray1,
      finalArray2: finalArray2,
      hexCodeArray: hexCodeArray,
      singleVariant: singleVariant,
      showQuickBuy: showQuickBuy,
      showSize: showSize
    }
    return ret;
  }
export const getVariantFinalOptions = (
    variants,productMainOptions,productTags,handle
  ) => {
      let { colors, sizes, letters } = getProductOptions(productMainOptions);
      const variantMap = mapVariants(variants, colors !== null, sizes !== null, letters !== null);
      
      let showQuickBuy = false;
      let singleVariant = false;
      let showSize = false;
      let finalColors = [];
      let finalSizes = [];
      let finalLetters = [];
      let hexCodeArray = [];

      if(productTags && productTags.includes("personalized")) {
        let finalOptionsData = getFinalOptions(sizes,letters,variantMap,'letter');
        finalSizes = finalOptionsData.finalArray1;
        finalLetters = finalOptionsData.finalArray2;
        showQuickBuy = finalOptionsData.showQuickBuy;
        singleVariant = finalOptionsData.singleVariant;
        showSize = finalOptionsData.showSize;
      } else {
        let finalOptionsData = getFinalOptions(sizes,colors,variantMap,'color');
        finalSizes = finalOptionsData.finalArray1;
        finalColors = finalOptionsData.finalArray2;
        hexCodeArray = finalOptionsData.hexCodeArray;
        showQuickBuy = finalOptionsData.showQuickBuy;
        singleVariant = finalOptionsData.singleVariant;
        showSize = finalOptionsData.showSize;
      }
      
      
      
      return { colors: finalColors, letters: finalLetters , sizes: finalSizes, variantMap: variantMap, 
        hexCodeArray: hexCodeArray, 
        showQuickBuy: showQuickBuy,
        singleVariant: singleVariant,
        showSize: showSize,
        handle: handle
      };
    
  };

  //this function returns if the variant is having variant metafield local_item
  export const hasLocalItem = (
    variantMap,key
  ) => {
    try{
      if(!variantMap || !key) {
        return false;
      }
      // Check if key is a color key
      if (variantMap[key]) {
        // key is a color
        return Object.values(variantMap[key]).some(
          variant => variant.local_item?.value?.toLowerCase() === "local"
        );
      }
    
      // Check if key is a size key inside any color
      for (const color in variantMap) {
        const sizeVariant = variantMap[color][key];
        if (sizeVariant?.local_item?.value?.toLowerCase() === "local") {
          return true;
        }
      }
      return false;
    } catch (error) {
      return false; // Return false in case of an error
    }
    
  };


// this helper function returns the hex code array for the color swatches
export const getHexCodeArray = (variantsFinalOptions) => {
  const variantMap = variantsFinalOptions?.variantMap || {};
  const hexCodeArray = [];

  for (const colorName in variantMap){
    const colorGroup = variantMap[colorName];
    const firstSizeKey = Object.keys(colorGroup)?.[0];
    const hexColorObj = colorGroup?.[firstSizeKey]?.hexColor;
    if(hexColorObj){
      const hex = Object.values(hexColorObj)?.[1];
      if(hex){
        hexCodeArray.push({colorName, hex});
      }
    }
  }

  //  remove duplicates
 return [...new Set(hexCodeArray)];
}